import { useState, useEffect } from 'react';
import { MySearch, commonSearch, MyTooltip, toast, Box } from "views/utilities/MyCustomFile"
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { IconMailShare } from '@tabler/icons-react';
import { postAPI } from "../axios/api";

export const MyTable = ({ columns, rows, fieldNames, searchField, checkboxSelection, tblID, useHereMail }) => {
    const [filteredRows, setFilteredRows] = useState(rows);
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const handleSortModelChange = (model) => setSortModel(model);
    const handleFilterModelChange = (model) => {
        setFilterModel(model);
        applyFilters(model);
    };
    const applyFilters = (model) => {
        try {
            const { items } = model;
            let filteredData = rows;
            if (filteredData && filteredData.length > 0) {
                items?.forEach((filter) => {
                    const { columnField, operatorValue, value } = filter;
                    filteredData = filteredData.filter((row) => {
                        const cellValue = row[columnField] ? row[columnField].toString().toLowerCase() : '';
                        switch (operatorValue) {
                            case 'contains':
                                return cellValue.includes(value.toString().toLowerCase());
                            case 'equals':
                                return cellValue === value.toString().toLowerCase();
                            default:
                                return true;
                        }
                    });
                });
            }
            setFilteredRows(filteredData);
        } catch (error) { console.log(error) }
    };
    useEffect(() => {
        setFilteredRows(rows);
    }, [rows]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        const filteredData = commonSearch(filteredRows, fieldNames, searchField || query)
        setSearchResults(filteredData);
    };
    useEffect(() => {
        if (searchField) {
            handleSearch({ target: { value: searchField } })
        }
    }, [searchField])

    const [emailID, setEmailID] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const handleSendEmail = async () => {
        try {
            setIsLoading(true)
            const { status, message } = await postAPI("email/send", emailID)
            status ? toast.success(message) : toast.error(message)
            setIsLoading(false)
        } catch (error) { toast.error(error) }
    }

    return (<>
        {Boolean(useHereMail) && emailID.length > 0 ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <span></span>
            <MyTooltip title={"Mail send"} placement={"right"} color={"primary"} onClick={handleSendEmail} disabled={isLoading} icon={isLoading ? <CircularProgress color="secondary" /> : <IconMailShare />} />
        </Box> : null}
        <MySearch label={"Search"} value={searchQuery} onChange={handleSearch} />
        <div style={{ height: 500, width: '100%' }}>
            <DataGrid
                rows={searchQuery ? searchResults : filteredRows || []}
                columns={columns}
                getRowId={(val) => val[tblID]}
                sortModel={sortModel}
                density="compact"
                filterModel={filterModel}
                onSortModelChange={handleSortModelChange}
                onFilterModelChange={handleFilterModelChange}
                pagination
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                pageSizeOptions={[10, 30, 50, 100]}
                components={{ Toolbar: GridToolbar }}
                checkboxSelection={Boolean(checkboxSelection)}
                onRowSelectionModelChange={(e) => setEmailID(e)}
            />
        </div>
    </>)
}